import { createActionGroup, props } from '@ngrx/store';

export const AppSettingsActions = createActionGroup({
	source: 'AppSettings',
	events: {
		'Add Is Geolocation Enabled': props<{ isGeolocationEnabled: boolean }>(),
	},
});
